/*
&.primary{
    background: #8231d3;
}
&.secondary{
    background: #5840FF;
}
&.success{
    background: #01B81A;
}
&.info{
    background: #00AAFF;
}
&.warning{
    background: #FA8B0C;
}
&.danger{
    background: #ff0f0f;
}
&.dark{
    background: #0A0A0A;
}
&.light{
    background: #8C90A4;
}
*/
import { colors } from "@/constant/constants";

const labels = [
    {
        id: 1,
        name: 'Lead Form',
        type: 'contact',
        color: colors.primary,
        class: 'primary'
    },
    {
        id: 2,
        name: 'Lead Generation',
        type: 'contact',
        color: colors.success,
        class: 'success'
    },
    {
        id: 3,
        name: 'Hot Lead',
        type: 'contact',
        color: colors.danger,
        class: 'danger'
    },
    {
        id: 4,
        name: 'Lead',
        type: 'contact',
        color: colors.secondary,
        class: 'secondary'
    },
    {
        id: 5,
        name: 'Contact',
        type: 'contact',
        color: colors.gray,
        class: 'light'
    },
    {
        id: 6,
        name: 'Negotiation',
        type: 'contact',
        color: colors.warning,
        class: 'warning'
    },
    {
        id: 7,
        name: 'Closing',
        type: 'contact',
        color: colors.primary,
        class: 'primary'
    },
    {
        id: 8,
        name: 'Not Interested',
        type: 'contact',
        color: colors.black,
        class: 'dark'
    },
    {
        id: 9,
        name: 'No Answer',
        type: 'contact',
        color: colors.info,
        class: 'info'
    },
    {
        id: 10,
        name: 'Family Event',
        type: 'event',
        class: 'primary',
        color: colors.primary
    },
    {
        id: 11,
        name: 'Work Event',
        type: 'event',
        class: 'success',
        color: colors.success
    }
];

const labelContacts = labels.filter(label => label.type === 'contact');
const labelEvents = labels.filter(label => label.type === 'event');
const privateTagIds = [1, 2, 3];
const contactTagId = 5;

export {
    labelContacts,
    labelEvents,
    contactTagId,
    privateTagIds
};